'use client';

import { useFetchIranianWomenData } from '../../_utils/use-fetch-iranian-women-data';
const HeroSectionImages = () => {
  const {
    data
  } = useFetchIranianWomenData();
  const bannerUrl = data?.header.image_url;
  return <div className='hero-images-container' dir='ltr' data-sentry-component="HeroSectionImages" data-sentry-source-file="hero-images.tsx">
            <div className='hero-marquee-strip'>
                <img src={bannerUrl} alt='بنر زنان پیشگام ایران' className='hero-banner-image' loading='eager' draggable={false} />
                <img src={bannerUrl} alt='بنر زنان پیشگام ایران' className='hero-banner-image' aria-hidden loading='eager' draggable={false} />
            </div>
        </div>;
};
export default HeroSectionImages;